import { initSentry, Sentry } from '../../shared/utils/sentry';
import { toastError } from '../../shared/utils/toast';
import { onMessage } from './messaging';

;(function() {
  initSentry();

  /**
   * Logs a given error to the console and displays a toast notification.
   * @param {unknown} err - The error to handle (can be any thrown value).
   * @returns {void}
   */
  const handle = (err, tags = {}) => {
    Sentry.captureException(err, { tags });
    console.error(err);
    toastError('Something went wrong. Please try again.');
  };

  // sync JS errors
  window.addEventListener('error', e => {
    handle(e.error || new Error(e.message));
    e.preventDefault();
  });

  // unhandled Promise rejections
  window.addEventListener('unhandledrejection', e => {
    handle(e.reason);
    e.preventDefault();
  });

  // top-level fetch() failures
  if (window.fetch) {
    const originalFetch = window.fetch;
    window.fetch = (...args) =>
      originalFetch(...args).catch(err => {
        handle(err);
        throw err;
      });
  }

  // errors forwarded from iframe
  onMessage(e => {
    const data = e.data || {};
    if (data.type === 'error') {
      const err = new Error(data.message);
      err.stack = data.stack;
      handle(err, { source: 'wizard' });
    }
  });
})();